import { createRouter } from "@tanstack/react-router";

import { queryClient } from "@services/query/queryClient.ts";
import { PageNotFound } from "@components/app/PageNotFound.tsx";
import { usePortalModeStore } from "@stores/usePortalModeStore";
import { routeTree } from "../../routeTree.gen";
import { useMsalAuthStore } from "@stores/useMsalAuthStore";
import { RoutePendingIndicator } from "@components/app/RoutePendingIndicator";
import { reportFrontendError } from "@services/telemetry/browserTracing";

// Create a new router instance
export const router = createRouter({
	routeTree,
	defaultOnCatch: (error, info) => reportFrontendError(error, "React", info.componentStack ?? undefined),
	defaultNotFoundComponent: PageNotFound,
	defaultPendingComponent: RoutePendingIndicator,
	defaultPendingMs: 200,
	context: {
		queryClient,
		auth: {
			get hostMode() {
				return usePortalModeStore.getState().hostMode;
			},
			get status() {
				return useMsalAuthStore.getState().status;
			},
			ensureAuth: async () => {
				return { status: useMsalAuthStore.getState().status };
			},
		},
	},
	defaultPreload: "intent",
	defaultPreloadDelay: 1,
});

// Register the router instance for type safety
declare module "@tanstack/react-router" {
	interface Register {
		router: typeof router;
	}
}
